import {Component, Injector, EventEmitter, Output} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { ToasterService } from '../../services/toaster.service';
import { AuthService } from '../../services/auth.service';

@Component({
    template: `
        <div class="user-popover-outline">
            <div class="user-popover">
                <div class="bar-header">
                    <h1 class="title ly_pop_title">포인트 선물</h1>
                    <a class="ly_pop_close" (click)="closePopover()"><mat-icon class="mat-icon-30 btn_close" svgIcon="xi-close"></mat-icon></a>
                </div>
                <form #sendPointForm="ngForm">
                    <div class="pop-body">
                        <div class="point_gift">
                            <ul>
                                <li>
                                    <div class="layout-row">
                                        <em style="width: 80px;margin-top: 2px;">받는사람</em>
                                        <div class="flex">
                                            <span class="ico_lv"><img [src]="'assets/images/common/lv/' + toUser.mb_level + '.png'" alt="" class="lvS1"></span>
                                            <span class="nick">{{toUser.mb_nick}}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="layout-row">
                                        <em style="width: 80px;margin-top: 10px;">포인트선물</em>
                                        <div class="flex">
                                            <mat-form-field floatLabel="never">
                                                <input matInput type="number" placeholder="포인트를 입력하세요." name="usepoint"  [(ngModel)]="gift.usepoint" ng-min="1000" ng-max="me.mb_point" required>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="layout-row">
                                        <em style="width: 80px;margin-top: 1px;">보유포인트</em>
                                        <div class="flex">
                                            <span class="point"><img src="assets/images/common/top_ico_point.png" alt=""> {{me.mb_point | number}}</span>
                                        </div>
                                    </div>
                                    <div class="layout-row">
                                        <p class="desc">포인트 선물은 1000 포인트 이상 부터 가능하며, 선물한 포인트는 취소, 환불이 불가합니다.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- .pop-body -->
                    <div class="pop-footer">
                        <button mat-button class="full btn_create" [disabled]="!sendPointForm.form.valid" (click)="giftPoint()"><span style="color: #fff;">선물하기</span></button>
                    </div>
                <!-- .pop-footer -->
                </form>
            </div>
        <!-- // 목표설정 -->
        </div>`,
        styleUrls: ['style.scss']
})


export class LayerPopPointGiftComponent {
   // private navCtrl: NavController;
    @Output() popclosed = new EventEmitter();

    gift: any = {usepoint: 0, to_user: null, from_user: null};
    toUser: any = {mb_nick: '', mb_level: ''};
    me: any = {mb_point: 0};

    constructor(
            private injector: Injector,
            private http: HttpService,
            protected toasterService: ToasterService,
            protected authService: AuthService) { // private :
        // this.navCtrl = app.getActiveNav();

        authService.mustLoggedIn();
        this.me = authService.getUser();

        const paramObj = this.injector.get('paramObj');

        this.gift.to_user = paramObj.to_user;
        this.gift.from_user = this.me.mb_id;

        this.receiverInfo();
    }

//    if (!this.gift.to_user) this.$parent.closePopoverPointGift();
    // 받을 사람 정보를 가져온다.
    private receiverInfo() {
        this.http.get({url: 'auth/userinfoById', params: {mb_id: this.gift.to_user}}).then((obj) => {
            this.toUser = obj.user;
            this.gift.to_user_nick = obj.user.mb_nick;
        });
    }

    giftPoint() {
        this.http.post({url: 'chat/gift-point', params: this.gift}).then((obj) => {
            if (obj.result) {
                this.authService.refresh((user) => {this.me = user; });
                this.toasterService.showToaster('info', '포인트가 정상적으로 전달되었습니다.');
                this.closePopover();
            } else {
                this.toasterService.showToaster('error', obj.message);
            }
        });
    }

    closePopover() {
        this.popclosed.emit();
    }
}
